export default __webpack_public_path__ + "static/media/cs-gif2.4205ca5c.gif";